// Copyright (c) 2016 Deere & Company

import './warranty-coverage-item.scss';
import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import Warranty from '@deere/cps-it.warranty-model-factory/lib/warranty';
import WarrantyCoverageItemRowJdProtect from './warranty-coverage-item-row-jd-protect';
import WarrantyCoverageItemRowOne from './warranty-coverage-item-row-one';
import WarrantyCoverageItemRowPlanName from './warranty-coverage-item-row-plan-name';
import WarrantyCoverageItemRowThree from './warranty-coverage-item-row-three';
import WarrantyCoverageItemRowTwo from './warranty-coverage-item-row-two';
import {buildNumber} from '../../../../shared/services/build-number';

const disabledClass = (showDisabledClass, warranty) =>
    showDisabledClass || warranty.daysRemaining === 0 || warranty.isExpired ? 'disabled' : '';

const WarrantyCoverageItem = (props, context) =>
    <section className={`warranty-coverage-item ${disabledClass(props.showDisabledClass, props.warranty)}`}>
        <div className='warranty-coverage-item-header'>
            <span className='warranty-coverage-item-name'>
                {props.warranty.warrantyType.value}
            </span>
            {props.warranty.daysRemaining === 0 || props.warranty.isExpired ?
                <FormattedMessage
                    id='EXPIRED'
                /> :
                    <FormattedMessage
                        id='DAYS_REMAINING_WITH_COUNT'
                        values={{
                            days: props.warranty.daysRemaining,
                            daysToDisplay: buildNumber(props.warranty.daysRemaining, {}, context.user.settings.general.decimalFormat.key)
                        }}
                    />}
        </div>
        {props.warranty.warrantyItemText &&
        <div className='warranty-coverage-item-text'>
            <span>
                {props.warranty.warrantyItemText}
            </span>
        </div>
        }
        <div className='item-details'>
            {props.warranty.planName &&
                <div>
                    <WarrantyCoverageItemRowPlanName
                        warranty={props.warranty}
                    />
                    <WarrantyCoverageItemRowTwo
                        warranty={props.warranty}
                    />
                </div>
            }
            <WarrantyCoverageItemRowOne
                warranty={props.warranty}
            />
            {props.warranty.planName &&
                <div>
                    <WarrantyCoverageItemRowJdProtect
                        warranty={props.warranty}
                    />
                    <WarrantyCoverageItemRowThree
                        maintenancePlanLink={props.maintenancePlanLink}
                        onClick={props.onClick}
                        warranty={props.warranty}
                    />
                </div>
            }
        </div>
    </section>;

WarrantyCoverageItem.displayName = 'WarrantyCoverageItem';
WarrantyCoverageItem.propTypes = {
    maintenancePlanLink: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    showDisabledClass: PropTypes.bool.isRequired,
    warranty: PropTypes.instanceOf(Warranty).isRequired
};

WarrantyCoverageItem.contextTypes = {
    user: PropTypes.instanceOf(User).isRequired
};

export default WarrantyCoverageItem;



// WEBPACK FOOTER //
// ./src/product/details/components/warranty-coverage-panel/warranty-coverage-item.js